import { useSuspenseQuery } from '@tanstack/react-query'

import { promotion } from './promotion'

export const usePromotion = (params: { promotionId: string }) => {
  const { data: state } = useSuspenseQuery(promotion(params.promotionId))
  return state
}
